import styled from 'styled-components';

export const FlexCol = styled.div`
  display: flex;
  flex-direction: column;
`;
